import React from 'react';
import {capitalize} from 'lodash';

interface Props {
  admissionLikelihoodScoreCategory: string | null;
}

const AdmissionLikelihoodTag = ({admissionLikelihoodScoreCategory}: Props) => {
  if (admissionLikelihoodScoreCategory === null) return null;

  return (
    <div className="admission-likelihood-tag" data-testid="admission-likelihood-tag">
      {!!admissionLikelihoodScoreCategory && capitalize(admissionLikelihoodScoreCategory)}
    </div>
  );
};

export default AdmissionLikelihoodTag;
